export const IOS_FAKE_CONTEXT_MENU_EVENT_DETAIL = 999;

export const NATIVE_APP_CUSTOM_DOM_EVENTS = {
    PENCIL_DOUBLE_TAP: 'pencildbltap',
} as const;

export const PENCIL_DOUBLE_TAP_PREFERRED_ACTIONS = {
    ignore: 'ignore',
    switchEraser: 'switchEraser',
    switchPrevious: 'switchPrevious',
    showColorPalette: 'showColorPalette',
    showInkAttribute: 'showInkAttributes',
} as const;
